"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var font = {
  primaryRegular: '\'Open Sans\', Arial, sans-serif',
  secondaryLight: 'loraregular, Arial, sans-serif',
  // Lora light doesn't exist, using loraregular
  secondaryRegular: 'loraregular, Arial, sans-serif',
  secondaryMedium: 'loraregular, Arial, sans-serif',
  secondarySemiBold: 'loraregular, Arial, sans-serif',
  secondaryBold: 'lorabold, Arial, sans-serif'
};
var _default = exports.default = font;